"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var createPrototypeExports_1 = require("./interfaces/createPrototypeExports");
var createPrototypeImports_1 = require("./interfaces/createPrototypeImports");
var create = function (state, getCreatorFunctions) {
    var _a, _b, _c;
    var config = (_b = (_a = getCreatorFunctions()).getModuleConfig) === null || _b === void 0 ? void 0 : _b.call(_a);
    var prototypeImports = (0, createPrototypeImports_1.createPrototypeImports)(state, getCreatorFunctions());
    var prototypeExports = (0, createPrototypeExports_1.createPrototypeExports)(config);
    return {
        payload: state,
        imports: __assign({}, prototypeImports),
        exports: prototypeExports,
        isSingletonPerDevice: config === null || config === void 0 ? void 0 : config.isSingletonPerDevice,
        isEntryPoint: (_c = config === null || config === void 0 ? void 0 : config.isEntryPoint) !== null && _c !== void 0 ? _c : true,
    };
};
exports.create = create;
//# sourceMappingURL=creator.js.map